import { Box, Container, Typography } from "@mui/material";
import Hero from "../../components/hero";
import Nav from "../../components/nav";

function BasePage({ children }) {
  return (
    <>
      <Hero />
      <Nav />
      {children}
      <Box>
        <Container sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: 2
        }}>
          <Typography variant="caption" sx={{ color: "#ffffff" }}>
            &copy; 2025 lokalaparlor.com
          </Typography>
        </Container>
      </Box>
    </>
  )
}

export default BasePage;